export default {
  title: 'Sale',

  labels: {
    score: 'point',
    defaultStoreroom: 'Default warehouse for personal sale',
    hasPreSaleInvoiceAge: 'Pre-sale invoice deleted after special time',
    preSaleInvoiceAge: 'Pre-sale invoice deleted after ... days.',
    hasPreReturnSaleInvoiceAge: 'Pre-sale return invoice deleted after special time',
    preReturnSaleInvoiceAge: 'Pre-sale return invoice deleted after ... days.',
    profitConversationRate: 'Profit conversation rate',
    enableRetailShipping: 'Retail sale has shipping',
    enableEditUnitPrice: 'Enable edit unit price',
    enableSalePoint: 'Enable sale point',
    enableCheckBalance: 'Check balance for create invoice',
    enableCredit: 'Enable credit in sale invoice receive',
    enableDept: 'Enable dept in sale invoice receive',
    enableWallet: 'Enable wallet in sale invoice receive',
    enableBanks: 'Enable banks in sale invoice receive',
    enableCashes: 'Enable cashes in sale invoice receive',
    enableGateways: 'Enable payment gateways in sale invoice receive'
  },

  notifications: {
    edit: {
      success: 'Edit sale setting successfully done',
      error: 'Edit sale setting has error'
    },

    parseError: {
      preSaleInvoiceAge: 'Number of days for delete pre-sale invoice is incorrect',
      preReturnSaleInvoiceAge: 'Number of days for delete pre-sale return invoice is incorrect'
    }
  }
}
